import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-unguarded-breeze-report",
  templateUrl: "./unguarded-breeze-report.component.html",
  styleUrls: ["./unguarded-breeze-report.component.css"],
})
export class UnguardedBreezeReportComponent implements OnInit {
  isReportPage: boolean = false;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.checkRoute(this.router.url);
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.checkRoute(event.urlAfterRedirects);
      });
  }

  checkRoute(url: string) {
    this.isReportPage = url.includes("breeze-report");
  }
}
